import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';

export default class VehicleService extends Singleton<VehicleService> {
  public getManufacturerList = async () => {
    const client = await ApiService();

    try {
      const manufacturerListResponse = await client.apis.vehicle.manufacturerList();
      const manufacturerList = manufacturerListResponse?.body;

      return manufacturerList?.manufacturers;
    } catch (e) {
      throw new Error(e);
    }
  };

  public getModelList = async ({ fromYear, toYear, manufacturerIds }) => {
    const client = await ApiService();

    try {
      const modelListResponse = await client.apis.vehicle.modelList({
        request: {
          request: {
            fromYear,
            toYear,
            manufacturerIds
          }
        }
      });

      return modelListResponse?.body?.models.sort(
        (a, b) => a.displayName.toLowerCase() - b.displayName.toLowerCase()
      );
    } catch (e) {
      throw new Error(e);
    }
  };
}
